import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IConnectedView, IMetric } from '../types/IMetric';
import { IPublishedConnection } from '../types/IPublishedConnection';
import { IRecent } from '../types/IRecent';
import { IViewUsageInfo } from '../types/IUsageInfo';
import { IUser } from '../types/IUser';
import { IView } from '../types/IView';
import { IWorkbook } from '../types/IWorkbook';
import { INamedItem } from '../types/resourceParts';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetDetailedRecentsResult extends IGetItemsResult {
  connectedViews?: IConnectedView[];
  metrics?: IMetric[];
  metricFavorites?: string[];
  publishedConnections?: IPublishedConnection[];
  publishedConnectionFavorites?: string[];
  projects?: INamedItem[];
  recents?: IRecent[];
  users?: IUser[];
  views?: IView[];
  workbooks?: IWorkbook[];
  viewMaxStats?: IViewUsageInfo;
  viewFavorites?: string[];
}

export class GetDetailedRecentsRequest extends Request<IGetItemsParams, IGetDetailedRecentsResult> {
  constructor(params: IGetItemsParams) {
    super('getDetailedRecents', params);
  }
}
